import React, { memo } from 'react'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'
import { Checkbox } from 'components/forms'

interface IDatOptionProps {
  isDatMarketApplicable: boolean | null
  origin?: string
  destination?: string
  onChange: (arg: Partial<ChangeRateData>) => void
}

export const DatOption = memo<IDatOptionProps>(
  ({ destination, isDatMarketApplicable, onChange, origin }) => {
    const onChecked = ({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ isDatMarketApplicable: checked })
    }

    return (
      <div className='row'>
        <div className='pv4 col-xs-12'>
          <Checkbox
            id='isDatMarketApplicable'
            dataTest='is-dat-applicable'
            label={`Also offer shipments within ${origin} - ${destination} at this rate`}
            checked={Boolean(isDatMarketApplicable)}
            onChange={onChecked}
          />
        </div>
      </div>
    )
  }
)
